import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SelectOptionI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { State } from '../../reducers';
import { getOneClickOwnFreightPlants } from '@ordersnproducts/modules/one-click-order/selectors/one-click-ownFreight-plants.selector';

@Injectable()
export class OneClickOwnFreightPlantsLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<State>) {}

  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(getOneClickOwnFreightPlants),
      map((plants) => {
        return plants.map((plant) => {
          return {
            id: plant.plantId,
            name: plant.plantDesc,
          };
        });
      }),
    );
  }
}
